import { render, staticRenderFns } from "./BackofficeSettings.vue?vue&type=template&id=175fb032&"
import script from "./BackofficeSettings.vue?vue&type=script&lang=js&"
export * from "./BackofficeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnToggle,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtnToggle,QCard})
